import {
    ReturnRequestsTimeChartItem,
    ValueCountDto,
} from "@babackapp/private-api-client/types";
import { useMemo } from "react";
import useCurrentFiltersReturnRequestsStats from "./use-current-filters-return-requests-stats";

type Key = keyof Pick<
  ReturnRequestsTimeChartItem,
  {
    [K in keyof ReturnRequestsTimeChartItem]: ReturnRequestsTimeChartItem[K] extends ValueCountDto
      ? K
      : never;
  }[keyof ReturnRequestsTimeChartItem]
>;

export default function useQuickStats(key: Key) {
  const { data: stats } = useCurrentFiltersReturnRequestsStats();

  return useMemo(() => {
    return (stats ?? []).reduce(
      (acc, next) => {
        const total =
          acc.total +
          next.discount.count +
          next.exchange.count +
          next.exchangeCredit.count +
          next.refund.count +
          next.unknown.count;

        return {
          count: acc.count + next[key].count,
          value: acc.value + next[key].value,
          total,
          percentage: total ? ((acc.count + next[key].count) / total) * 100 : 0,
        };
      },
      { count: 0, value: 0, total: 0, percentage: 0 },
    );
  }, [stats, key]);
}
